/*
  Command state
*/
export default {
  list: []
}
